<template>
    <div class="Topnav" v-if="this.$route.path!='/login' && this.$route.path!='/register' && this.$route.path!='/download'">
        <ul class="TopNavUl clearfix">
            <li @click="gotoHome()">欢迎来到浙江温周!</li>
            <!--<li v-if="username !== null && username !== ''" style="color: #2e98d5;position:relative" class="userInfoLi">
                <router-link to="/userCenter/userInfo">{{ username }}</router-link> <span @click="loginOut()" class="loginOut">[退出]</span>
            </li>
            <li v-else style="color:#2e98d5" class="loginOrRegister">
                <span @click="goToLogin()" style="width: 45px;text-align: left;display: inline-block">请登录</span>
                <span class="csd">|</span>
                <span @click="goToRegister()" style="width: 35px;text-align: right;display: inline-block">注册</span>
            </li>
            <li style="float: right">
                <dl class="clearfix topNavRight">
                    <li class="shoppingCart" @click="toCart()">购物车({{commdityNumber}})</li>
                    <li><router-link to="/userCenter/collection">收藏夹</router-link></li>
                    <li @click="toUserCenter()">用户中心</li>
                    <li><router-link to="/explain">帮助中心</router-link></li>
                    <li>客服: 88888888</li>
                </dl>
            </li>-->
        </ul>
    </div>

</template>

<script>
import { LoginService } from '@/service/login.service';
import { UserCenterService } from '../../service/userCenter.service';
export default {
    data() {
        return {
            cartList: [{
                name: "阿司匹林",
                price: 20,
                Specifications: "10mg*12片",
                number: 2
            },{
               name: "阿司匹林A",
                price: 30,
                Specifications: "10mg*20片",
                number: 3 
            },
            {
               name: "阿司匹林B",
                price: 30,
                Specifications: "10mg*20片",
                number: 3 
            }],
            userRouterList: [],
        }
    },
    async created() {
        if (localStorage.getItem('token') && !await UserCenterService.checkToken()) {
            this.loginOut();
        } else if(!localStorage.getItem('token')) {
            this.clearStorage();
        }
    },
    computed: {
        username() {
            return this.$store.getters.username || localStorage.getItem('username');
        },
        commdityNumber() {//获取购物车商品数量
                let number = this.$store.getters.cartAmount
                return number
        }
    },
    activated() {
        console.log('created')
    },
    beforeRouteUpdate(to, form, next) {
        console.log(to, form);
        next();
    },
    methods: {
        async loginOut() {
            await LoginService.loginOut(localStorage.getItem('token'))
            this.clearStorage();
            location.reload();
            this.$store.commit('SET_NAME','')
        },
        clearStorage() {
            this.$store.commit('SET_NAME','')
            localStorage.removeItem('username')
            localStorage.removeItem('token')
        },
        gotoHome() {
            this.$router.push('/')
        },
        goToLogin() {
            this.$router.push('/login')
        },
        goToRegister() {
            this.$router.push({path:'/register',query:{model:'userRegister'}})
        },
        toCart() {
            this.$router.push('/shoppingCart');
        },
        toUserCenter() {
            this.$router.push({path:'/userCenter/userInfo'})
        }
    }
}
</script>
<style scoped>
    .Topnav{
        width: 100%;
        background: #f6f5f5;
        height: 30px;
        line-height: 30px;
        border-bottom: 1px solid #e3e2e1;
        position: sticky;
        top: 0;
        z-index: 10;
    }
    .TopNavUl{
        width: 1200px;
        margin: 0 auto;
    }
    .TopNavUl li{
        float: left;
        cursor: pointer;
    }
    .userInfoLi{
        width: 200px;
        margin-left: 45px;
        cursor: pointer;
    }
    .loginOrRegister{
        width: 200px;
        margin-left: 45px;
    }
    .topNavRight li{
        float: left;
        margin-left: 35px;
    }
    .shoppingCart{
        background: url('../../assets/images/icon/shoppingCartIcon.png') left center no-repeat;
        background-size: 25px;
        text-indent: 2.5em;
    }
    .loginOut:hover{
        text-decoration: underline;
        color: #e4221c;
    }
</style>